export type ChoiceType = {
  options: string[];
  sendMessage: (message?: string, selectedOptions?: string[]) => void;
  disabled?: boolean;
};
